import styled from "@emotion/styled";

export const NavbarContainer = styled.div`
  height: auto;
  width: 100%;
  padding: 12px 16px;
  flex-direction: column;
  background: #003b21;
  justify-content: flex-start;
  align-items: center;
  gap: 39px;
  display: inline-flex;

  @media (min-width: 769px) {
    padding: 5px 16px;
  }
`;

export const TopSection = styled.div`
  width: 100%;
  flex: 1 1 0;
  height: 37.91px;
  justify-content: space-between;
  align-items: center;
  display: flex;
`;

export const Logo = styled.img`
  width: 94px;
  height: 28px;
`;

export const ProfileSection = styled.div`
  height: 37.91px;
  width: 55vw;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 4px;
  display: flex;
`;

export const ProfileCard = styled.img`
  width: 47.72px;
  height: 34.02px;
  transform: rotate(-5deg);
  transform-origin: top left;
`;

export const UserInfo = styled.div`
  width: 105px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: inline-flex;
`;

export const PlanText = styled.div`
  align-self: stretch;
  color: #e7c394;
  font-size: 10px;
  font-family: Roboto;
  font-weight: 400;
  line-height: 18px;
  word-wrap: break-word;
`;

export const NameText = styled.div`
  align-self: stretch;
  color: white;
  font-size: 12px;
  font-family: Roboto;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.24px;
  word-wrap: break-word;
`;
